import { useState, useCallback } from 'react';

/**
 * Custom hook for managing Quick Options popup state and actions
 */
export const useQuickOptions = () => {
  const [showQuickOptionsPopup, setShowQuickOptionsPopup] = useState(false);

  // Open the quick options popup
  const openQuickOptions = useCallback(() => {
    setShowQuickOptionsPopup(true);
  }, []);

  // Close the quick options popup
  const closeQuickOptions = useCallback(() => {
    setShowQuickOptionsPopup(false);
  }, []);

  // Toggle the quick options popup
  const toggleQuickOptions = useCallback(() => {
    setShowQuickOptionsPopup(prev => !prev);
  }, []);

  // Handle quick option selection
  const handleQuickOptionSelect = useCallback((option) => {
    console.log('🔍 Quick option selected:', option);
    
    // Close the popup first
    setShowQuickOptionsPopup(false);
    
    // Handle different action types
    switch (option.action) {
      case 'prompt':
        // Send a prompt to the chat
        console.log('💬 Sending prompt:', option.prompt);
        return { action: 'prompt', prompt: option.prompt, option };
        
      case 'help':
        // Show help information
        console.log('❓ Showing help...');
        return { action: 'help', option };
        
      default:
        console.log('❓ Unknown action:', option.action);
        return { action: 'unknown', option };
    }
  }, []);

  return {
    // State
    showQuickOptionsPopup,
    
    // Actions
    openQuickOptions,
    closeQuickOptions,
    toggleQuickOptions,
    setShowQuickOptionsPopup,
    handleQuickOptionSelect
  };
};

export default useQuickOptions;
